import { Fragment, useEffect, useState } from "react"
import { Controller } from "react-hook-form"
import { useSelector } from "react-redux"
import { XMarkIcon } from "@heroicons/react/20/solid"
import InputGroup from "@/(front-desk)/components/form/InputGroup"
import classNames from "classnames"
import Select from 'react-select'
import axios from "axios"

export default function Update({ control, project, certificate_type, setStep, isValid }) {

    const global = useSelector((state) => state.global)
    const user = project.applicants.find((a) => a.is_captain)?.user
    const [ applicantName, setApplicantName ] = useState('')
    const [ applicantNameEN, setApplicantNameEN ] = useState('')
    const [ advisorName, setAdvisorName ] = useState('')
    const [ schoolName, setSchoolName ] = useState('')
    const [ departmentList, setDepartmentList ] = useState([])
    const [ departmentName, setDepartmentName ] = useState('')

    useEffect(() => {
        if (schoolName) {
            setDepartmentList([])
            updateDepartmentList(schoolName)
        }
    }, [schoolName])

    function updateDepartmentList(schoolName) {
        const code = global.schoolList?.find((e) => e.label === schoolName).code
        axios.get(`/api/v1/activity/years/${global.currentExhibitYear}/schools/${code}/departments`)
        .then((res) => {
            // console.log(`${res.config?.url}: `, res.data)
            setDepartmentList(res.data.body.map((e) => {
                return {
                    label: e.name, value: e.name, code: e.moe_code
                }
            }))
        })
        .catch((err) => {
            // console.log(`${err.config?.url} fail: `, err)
            reportError(err, true)
        })
    }

    return (
        <Fragment>
            <div className="text-[1.5rem] font-semibold mb-2">
                {certificate_type?.label}
                {certificate_type?.shortcut === 'award' && '獲獎證明'} 資訊變更
            </div>
            <div className="text-[0.875rem text-black-700 font-light mb-6">
                請按照指示規格填寫希望變更的資訊內容。
            </div>
            <div className="text-[0.875rem] text-black-700 font-light mb-1">
                申請者帳號（收件信箱）
            </div>
            <div className="mb-4">
                {user.name} ({user.email})
            </div>
            <div className="text-[0.875rem] text-black-700 font-light mb-1">
                申請作品
            </div>
            <div className="mb-4">
                #{project.serial_no} {project.project_name}
            </div>
            <div className="text-[0.875rem] text-black-700 font-light mb-1">
                申請證書類別
            </div>
            <div className="mb-6">
                {certificate_type?.label}
                {certificate_type?.shortcut === 'award' && ' 獲獎證明'}
            </div>
            <InputGroup className="mb-4">
                <label className="!text-[0.875rem] !text-black-700 !font-light !mb-2.5">
                    作品標註校系（必填）
                </label>
                <Controller
                    control={control}
                    name="units"
                    rules={{required: true}}
                    render={({ field }) => (
                        // console.log('field', field), 
                        <Fragment>
                            <div className={classNames('flex items-center flex-wrap gap-2.5', {
                                'mb-2.5': field.value?.length > 0
                            })}>
                                { field.value?.map((name, index) => (
                                    <div
                                        key={`unit-${index}`}
                                        className="flex-center gap-1 bg-main-600 py-1 px-2 text-[1.125rem] text-white rounded-[0.5rem]"
                                    >
                                        {name}
                                        <button
                                            type="button"
                                            onClick={() => {
                                                field.onChange(field.value.filter((_, i) => i !== index))
                                            }}
                                        ><XMarkIcon className="w-4 fill-main-700" /></button>
                                    </div>
                                ))}
                            </div>
                            <div className="w-full flex items-center gap-1 mb-2">
                                <Select
                                    inputId="school-name"
                                    className="react-search w-full"
                                    classNamePrefix="react-search"
                                    placeholder="新增合作學校"
                                    inputRef={field.ref}
                                    options={global.schoolList}
                                    value={global.schoolList?.find(e => e.label === schoolName) || ''}
                                    onChange={(e) => { setSchoolName(e.label) }}
                                />
                                <Select
                                    inputId="department-name"
                                    className="react-search w-full"
                                    classNamePrefix="react-search"
                                    placeholder="選擇科系"
                                    value={departmentList.find(e => e.label === departmentName) || ''}
                                    inputRef={field.ref}
                                    options={departmentList}
                                    onChange={(e) => { setDepartmentName(e.label) }}
                                />
                            </div>
                            <div className="w-full flex justify-end">
                                <button
                                    type="button"
                                    className="btn-outline-main !py-3 whitespace-nowrap"
                                    onClick={() => {
                                        field.onChange([...field.value, [schoolName, departmentName]])
                                        setSchoolName('')
                                        setDepartmentName('')
                                    }}
                                    disabled={!schoolName || !departmentName}
                                >＋ 新增</button>
                            </div>
                        </Fragment>
                    )}
                />
            </InputGroup>
            <InputGroup className="mb-4">
                <label className="!text-[0.875rem] !text-black-700 !font-light !mb-2.5">
                    作品作者中文姓名（必填）
                </label>
                <Controller
                    control={control}
                    name="applicant_names"
                    rules={{required: true}}
                    render={({ field }) => (
                        // console.log('field', field), 
                        <Fragment>
                            <div className={classNames('flex items-center flex-wrap gap-2.5', {
                                'mb-2.5': field.value?.length > 0
                            })}>
                                { field.value?.map((name, index) => (
                                    <div
                                        key={`applicant-${index}`}
                                        className="flex-center gap-1 bg-main-600 py-1 px-2 text-[1.125rem] text-white rounded-[0.5rem]"
                                    >
                                        {name}
                                        <button
                                            type="button"
                                            onClick={() => {
                                                field.onChange(field.value.filter((_, i) => i !== index))
                                            }}
                                        ><XMarkIcon className="w-4 fill-main-700" /></button>
                                    </div>
                                ))}
                            </div>
                            <div className="flex items-center gap-1">
                                <input
                                    ref={field.ref}
                                    type="text"
                                    placeholder="新增其他作者"
                                    value={applicantName}
                                    onChange={(e) => {
                                        setApplicantName(e.target.value)
                                    }}
                                />
                                <button
                                    type="button"
                                    className="btn-outline-main !py-3 whitespace-nowrap"
                                    onClick={() => {
                                        field.onChange([...field.value, applicantName])
                                        setApplicantName('')
                                    }}
                                    disabled={!applicantName}
                                >＋ 新增</button>
                            </div>
                        </Fragment>
                    )}
                />
            </InputGroup>
            { certificate_type?.shortcut === 'award' &&
                <InputGroup className="mb-4">
                    <label className="!text-[0.875rem] !text-black-700 !font-light !mb-2.5">
                        作品作者英文姓名（必填）
                    </label>
                    <Controller
                        control={control}
                        name="applicant_names_en"
                        rules={{required: true}}
                        render={({ field }) => (
                            // console.log('field', field), 
                            <Fragment>
                                <div className={classNames('flex items-center flex-wrap gap-2.5', {
                                    'mb-2.5': field.value?.length > 0
                                })}>
                                    { field.value?.map((name, index) => (
                                        <div
                                            key={`applicant-${index}`}
                                            className="flex-center gap-1 bg-main-600 py-1 px-2 text-[1.125rem] text-white rounded-[0.5rem]"
                                        >
                                            {name}
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    field.onChange(field.value.filter((_, i) => i !== index))
                                                }}
                                            ><XMarkIcon className="w-4 fill-main-700" /></button>
                                        </div>
                                    ))}
                                </div>
                                <div className="flex items-center gap-1">
                                    <input
                                        ref={field.ref}
                                        type="text"
                                        placeholder="新增其他作者"
                                        value={applicantNameEN}
                                        onChange={(e) => {
                                            setApplicantNameEN(e.target.value)
                                        }}
                                    />
                                    <button
                                        type="button"
                                        className="btn-outline-main !py-3 whitespace-nowrap"
                                        onClick={() => {
                                            field.onChange([...field.value, applicantNameEN])
                                            setApplicantNameEN('')
                                        }}
                                        disabled={!applicantNameEN}
                                    >＋ 新增</button>
                                </div>
                            </Fragment>
                        )}
                    />
                </InputGroup>
            }
            <InputGroup className="mb-9">
                <label className="!text-[0.875rem] !text-black-700 !font-light !mb-2.5">
                    指導老師 {certificate_type?.shortcut === 'advisor' && '（必填）'}
                </label>
                <Controller
                    control={control}
                    name="advisor_names"
                    rules={{required: certificate_type?.shortcut === 'advisor'}}
                    render={({ field }) => (
                        // console.log('field', field), 
                        <Fragment>
                            <div className={classNames('flex items-center flex-wrap gap-2.5', {
                                'mb-2.5': field.value?.length > 0
                            })}>
                                { field.value?.map((name, index) => (
                                    <div
                                        key={`advisor-${index}`}
                                        className="flex-center gap-1 bg-main-600 py-1 px-2 text-[1.125rem] text-white rounded-[0.5rem]"
                                    >
                                        {name}
                                        <button
                                            type="button"
                                            onClick={() => {
                                                field.onChange(field.value.filter((_, i) => i !== index))
                                            }}
                                        ><XMarkIcon className="w-4 fill-main-700" /></button>
                                    </div>
                                ))}
                            </div>
                            <div className="flex items-center gap-1">
                                <input
                                    ref={field.ref}
                                    type="text"
                                    placeholder="新增其他指導老師"
                                    value={advisorName}
                                    onChange={(e) => {
                                        setAdvisorName(e.target.value)
                                    }}
                                />
                                <button
                                    type="button"
                                    className="btn-outline-main !py-3 whitespace-nowrap"
                                    onClick={() => {
                                        field.onChange([...field.value, advisorName])
                                        setAdvisorName('')
                                    }}
                                    disabled={!advisorName}
                                >＋ 新增</button>
                            </div>
                        </Fragment>
                    )}
                />
            </InputGroup>
            <button
                type="button"
                className="w-full btn-black btn-round mb-3"
                onClick={() => { setStep('confirm') }}
                disabled={!isValid}
            >下一步</button>
            <button
                type="button"
                className="w-full btn-outline-black btn-round"
                onClick={() => {
                    if (!isValid) {
                        setStep('info')
                    }
                    else {
                        setStep('confirm')
                    }
                }}
            >返回</button>
        </Fragment>
    )
}